<template>
    <div id="app">
      <router-view/>
      <!--
        <TopBar />
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-1">
            </div>
            <div class="col-sm-3" style="padding:20px;">
              <nav class="nav flex-column">
                <a class="nav-link active agrey" href="#/tools">Utilitaires</a>
                <a class="nav-link agrey" href="#/usb">Setup Programmer USB</a>
                <a class="nav-link agrey" href="#/kiprog">Setup KiProg</a>
              </nav>
            </div>
            <div class="col-sm-7">
              <router-view/>
            </div>
            <div class="col-sm-1">
            </div>
          </div>
        </div>
      -->
    </div>
</template>
<script>
    import HelloWorld from './components/HelloWorld.vue';
    import i18n from '@/plugins/i18n';
    import TopBar from './components/TopBar.vue'

    export default {
        name: 'app',
        components: {
            HelloWorld,
            TopBar
        },
        data() {
            return {
                languages: [
                    { flag: 'us', language: 'en', title: 'English' },
                    { flag: 'nl', language: 'nl', title: 'Nl' },
                    { flag: 'de', language: 'de', title: 'German' },
                    { flag: 'fr', language: 'fr', title: 'Français' }
                ]
            };
        },
        methods: {
            changeLocale(locale) {
                alert(navigator.languages)
                i18n.locale = locale;
            }
        }
    }
</script>

<style scoped>
    a {
      color:grey;
        /*font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;*/
    }
    .agrey {
      color:grey;
    }
</style>
